import { render, staticRenderFns } from "./viewTotalInventory.vue?vue&type=template&id=60ed5211&scoped=true&"
import script from "./viewTotalInventory.vue?vue&type=script&lang=js&"
export * from "./viewTotalInventory.vue?vue&type=script&lang=js&"
import style0 from "./viewTotalInventory.vue?vue&type=style&index=0&id=60ed5211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed5211",
  null
  
)

export default component.exports